import React from 'react';
import styled from 'styled-components';
import { pitchTheme } from '../styles/theme';

const Frame = styled.div<{ $fill?: boolean; $radius: number }>`
  position: relative;
  width: ${({ $fill }) => ($fill ? '100%' : 'min(100%, 320px)')};
  height: ${({ $fill }) => ($fill ? '100%' : 'auto')};
  padding: ${({ $fill }) => ($fill ? '0' : '12px')};
  background: ${({ $fill }) => ($fill ? 'transparent' : '#fff')};
  box-shadow: ${({ $fill }) => ($fill ? 'none' : '0 8px 24px rgba(0, 0, 0, 0.08)')};
  border-radius: ${({ $radius, $fill }) =>
    $fill ? `min(${$radius}px, 50%)` : `${$radius}px`};
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Image = styled.img<{ $radius: number; $fill?: boolean }>`
  display: block;
  width: 100%;
  height: ${({ $fill }) => ($fill ? '100%' : 'auto')};
  aspect-ratio: ${({ $fill }) => ($fill ? 'unset' : '4 / 3')};
  object-fit: cover;
  border-radius: ${({ $radius, $fill }) => ($fill ? 0 : $radius)}px;
  user-select: none;
  -webkit-user-drag: none;
  pointer-events: none;
`;

const Tape = styled.span<{ $position: 'top-left' | 'bottom-right' }>`
  position: absolute;
  width: 52px;
  height: 18px;
  background: ${pitchTheme.accent};
  opacity: 0.95;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  z-index: 1;
  ${({ $position }) =>
    $position === 'top-left'
      ? `
    top: 4px;
    left: 18px;
    transform: rotate(-38deg);
  `
      : `
    bottom: 8px;
    right: 18px;
    transform: rotate(-38deg);
  `}
`;

interface TapePhotoProps {
  src: string;
  alt: string;
  borderRadius?: number;
  fillFrame?: boolean;
  showTape?: boolean;
}

const TapePhoto: React.FC<TapePhotoProps> = ({
  src,
  alt,
  borderRadius = 0,
  fillFrame = false,
  showTape = true,
}) => {
  const radius = Math.max(0, borderRadius);
  const tapeVisible = showTape && !fillFrame && radius < 8;

  return (
    <Frame $fill={fillFrame} $radius={radius}>
      {tapeVisible && <Tape $position="top-left" aria-hidden />}
      <Image src={src} alt={alt} $radius={radius} $fill={fillFrame} draggable={false} />
      {tapeVisible && <Tape $position="bottom-right" aria-hidden />}
    </Frame>
  );
};

export default TapePhoto;
